import { getFirebaseServices } from '@/config/firebase';
import { getToken as getAppCheckToken } from 'firebase/app-check';

export type LeadSource = 'homepage_waitlist' | 'contact_form' | 'blog_newsletter';

export interface MarketingLeadInput {
  source: LeadSource;
  email: string;
  name?: string;
  company?: string;
  message?: string;
  intent?: string;
  pagePath?: string;
  phone?: string;
}

const getApiBase = (): string => {
  const explicit = import.meta.env.VITE_PUBLIC_API_BASE_URL as string | undefined;
  if (explicit && explicit.trim()) return explicit.replace(/\/$/, '');
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined;
  const region = (import.meta.env.VITE_FIREBASE_REGION as string | undefined) || 'us-central1';
  if (projectId && projectId.trim()) return `https://${region}-${projectId}.cloudfunctions.net`;
  return window.location.origin.replace(/\/$/, '');
};

export async function submitMarketingLead(input: MarketingLeadInput): Promise<void> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };

  try {
    const { appCheck } = await getFirebaseServices();
    if (appCheck) {
      const tokenResult = await getAppCheckToken(appCheck, false);
      if (tokenResult?.token) {
        headers['X-Firebase-AppCheck'] = tokenResult.token;
      }
    }
  } catch (error) {
    console.warn('[leadCapture] App Check token fetch failed; continuing without token.', error);
  }

  const response = await fetch(`${getApiBase()}/captureMarketingLead`, {
    method: 'POST',
    headers,
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({ error: 'Unable to submit lead.' }));
    throw new Error(data?.error || 'Unable to submit lead.');
  }
}
